export default "__VITE_ASSET__Cia1_Kob__"